module.exports = __webpack_public_path__ + "img/branch_normal.cfead11.png";